export const regionOptions = [
  { label: 'US', value: 'us' },
  { label: 'EU', value: 'eu' }
]
